module.exports = __webpack_public_path__ + "static/img/Courtney-Nevin.5a93fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Courtney-Nevin.jpg
// module id = KIhd
// module chunks = 0